import(/* webpackMode: "eager", webpackExports: ["AboutHero"] */ "/Users/yoko/renehuemer.com/website/src/components/sections/about-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Table","TableCaption","TableHeader","TableRow","TableHead","TableBody","TableCell"] */ "/Users/yoko/renehuemer.com/website/src/components/ui/table.tsx");
